import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';
import { get } from '@/utils/api';
import { useQuery } from '@tanstack/react-query';
import { GeneratorSearchParams, featureKeys, featurePath } from '.';
import { Generator, ModelID } from '@/types';

type QueryFnType = typeof fetchGenerators;

type UseGeneratorsOptions = {
  location: ModelID;
  search?: GeneratorSearchParams;
  config?: QueryConfig<QueryFnType>;
};

export const fetchGenerators = (location: ModelID, search: GeneratorSearchParams = {}) =>
  get<Generator[]>(`${featurePath}?franchise_id=${location}`, search);

export const useGenerators = ({ location, search = {}, config = {} }: UseGeneratorsOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: featureKeys.list(location, search),
    queryFn: () => fetchGenerators(location, search),
  });
};
